import React, { PureComponent } from "react";
import GridItem from "./GridItem/GridItem";
import NoContent from "../NoContent/NoContent";
import { Container, Grid as GridMui } from "@mui/material";
import Loading from "../../ui/Loading";

class Grid extends PureComponent {
    state = {
        assets: [],
        page: 0,
        loading: false,
        enableLoading: false,
    };

    componentDidMount() {
        this.loadAssets();
        window.addEventListener("scroll", this.onScroll);
    }

    loadAssets = () => {
        const { loading, page } = this.state;
        if (loading) return;
        this.setState({ loading: true });
        
        const { dataSource, fetchAssets, filters } = this.props;
        if (typeof fetchAssets === "function") {
            fetchAssets({ page: page + 1, filters })
                .then((newAssets) => {
                    this.setState((state) => ({
                        assets: [...state.assets, ...newAssets],
                        page: state.page + 1,
                        enableLoading: newAssets.length > 0,
                        loading: false,
                    }));
                })
                .catch(() =>
                    this.setState({ loading: false, enableLoading: false })
                );
        } else if (Array.isArray(dataSource)) {
            this.setState({
                assets: dataSource,
                enableLoading: false,
                loading: false,
            });
        }
    };

    onScroll = () => {
        const { loading, enableLoading } = this.state;
        if (loading || !enableLoading) return;
        const scrollTo =
            window.pageYOffset || document.documentElement.scrollTop;
        const newWindowHeight =
            document.documentElement.offsetHeight - window.innerHeight;
        const percentDocument = (scrollTo * 100) / newWindowHeight;
        if (percentDocument > 80) {
            this.loadAssets();
        }
    };

    getGridItemFromAsset = (asset) => {
        const { lazyLoadingThumbnails, gridItemProps } = this.props;
        return (
            <GridMui key={asset.id} item xs={12} sm={6} lg={4}>
                <GridItem
                    asset={asset}
                    lazyLoadingThumbnails={lazyLoadingThumbnails}
                    {...gridItemProps}
                />
            </GridMui>
        );
    };

    render() {
        const { assets, loading, enableLoading } = this.state;
        const { noResultsText, filters: {sort = null, category = null}  } = this.props;
        const filteredBy = category ? "category" : "none";
        const sortedBy = sort ? sort : "none";
        return (
            <div 
                data-testid="tvp-grid"
                data-filteredby={filteredBy}
                data-sortedby={sortedBy}
            >
                <Container>
                    {!enableLoading &&
                        (!assets || !assets.length) &&
                        !loading && (
                            <NoContent>
                                <div className={"no-results"}>
                                    {noResultsText}
                                </div>
                            </NoContent>
                        )}
                    <GridMui container spacing={2}>
                        {assets.map(this.getGridItemFromAsset)}
                    </GridMui>
                    {loading && <Loading />}
                </Container>
            </div>
        );
    }
}

Grid.defaultProps = {
    dataSource: [],
    fetchAssets: null,
    filters: {},
    gridItemProps: {},
    lazyLoadingThumbnails: true,
    noResultsText: "No results found.",
};

export default Grid;
